import React, { useEffect, useState } from "react";
//import "./productstable.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPencil,
    faTrash,
    faEye,
} from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../../common/Pagination";
import { useDispatch, useSelector } from "react-redux";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from "@mui/material/Button";

import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, TextField } from "@mui/material";
import { DataGrid, GridApi, GridColDef, GridValueGetterParams, GridCellParams, gridClasses, GridColumnHeaderParams } from '@mui/x-data-grid';
import { CustomerService } from "../../../service/customers.service";
import { alpha, styled } from '@mui/material/styles';
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';
import RetailAccountDetails from "./RetailAccountDetails";
import AddRetailUserDialog from "./AddRetailUserDialog";
import CloseIcon from '@mui/icons-material/Close';


function RetailCustomers() {

    const customerService = new CustomerService();

    const [retAccountsData, setRetAccountsData] = useState<any[]>([]);
    
    const [selectedUser, setSelectedUser] = useState<any>();

    //const [availableStatus, setAvailableStatus] = useState<OrderStatus[]>([]);

    const navigate = useNavigate();

    const toRetailAccountDetails = (bIndex: string, action: string) => {
                 
                        
      //  navigate('../retailAccountdetails',{state:{                   
            /*finishDetails : finishesData[Number(bIndex)-1],
            finishesData: finishesData ,
            action : action*/
     //   }})
     var user = retAccountsData[Number(bIndex)-1]
     console.log(user)
     setSelectedUser(user)
     setOpen(true)
};


    const [open, setOpen] = React.useState(false);
    const [openAdd, setOpenAdd] = React.useState(false);

    /*
    "status": 0,
    "colorId": 1,
    "colorCode": "ZN",
    "colorDesc": "Zink"
    */

    const columns: GridColDef[] = [
        {field: 'id', headerName: 'Id', width: 70},
        {field: 'name', headerName: 'Name', flex: 1},
        {field: 'mobile', headerName: 'Mobile Number', flex: 1},
        {field: 'mail', headerName: 'Email', flex: 1},
        {field: 'role', headerName: 'User Role', flex: 1 },
        
      
        {field: 'statusColumn', headerName: 'Status', flex: 1,
            renderCell: (params) => {
                return <div>
                    {params.value == 'Unknown' && (<p style={{ color: "blue" }}>Unknown</p>)
                        || params.value == 'Deactive' && (<p style={{ color: "red" }}>Deactive</p>)
                        || params.value == 'Active' && (<p style={{ color: "green" }}>Active</p>)
                    }
                </div>
            }
        },
        
        {field: 'dateC', headerName: 'Created Date', flex: 1 },
        {field: 'dateU', headerName: 'Updated Date', flex: 1 },


        {
            field: "action",
            headerName: "Action",
            sortable: false,
            renderCell: (params) => {
                const onClick = (e: { stopPropagation: () => void; }) => {
                    e.stopPropagation(); // don't select this row after clicking

                    const api: GridApi = params.api;
                    const thisRow: Record<string, GridCellParams> = {};

                    api
                        .getAllColumns()
                        .filter((c: { field: string; }) => c.field !== "__check__" && !!c)
                        .forEach(
                            (c: { field: string | number; }) => (thisRow[c.field] = params.value.getValue(params.id, c.field))
                        );

                };

                return <div>
                    <Button onClick={(e) => toRetailAccountDetails(params.value, "edit")} > <IconButton> <EditTwoToneIcon fontSize="small" /></IconButton></Button>

                </div>
            },
            flex: 1
        }

    ];
 
    const loadData = () => {

        customerService.retailCustomerAccounts().then(data => {
            const res = data.data;
            //console.log('finishesData', res)
            let cnt1 = 0;
            const peopleWithImages = res.map((person: any, index: any) => {
                cnt1 = cnt1 + 1;

        
                var statusValue = "Unknown"
                if (person.status == -1) {
                    statusValue = "Unknown";
                } else     if (person.status == 0) {
                    statusValue = "Deactive";
                } else  if (person.status == 1) {
                    statusValue = "Active";
                }

                
                return {
                    ...person,
                    id: person.userId,
                    name: person.username,
                    mobile: person.mobileno,
                    mail: person.email,
                    pin:person.pin,
                    role: person.userrole,
                    entName: person.entName,
                    statusColumn: statusValue,
                    status : person.status,
                    dateC: person.DateC,
                    dateU:person.DateU,
                    action: cnt1,
                };

            });
            setRetAccountsData(peopleWithImages)


        });

    }
    
   

    let isLoadDataInit = false;
    useEffect(() => {

        if (!isLoadDataInit) {
            isLoadDataInit = true;
            loadData();
        }

    }, [])


    // dialog 

    const handleCallBack = () => {

        setOpen(false);
        loadData();

       /* toast.success("Updated Successfully !!!", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 2000,
            hideProgressBar: true,
          }); */        
    };

 

    const handleClose = () => {
        console.log("opppppppppppppppppppppppppppppppppp")
        setOpen(false);
    };

    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
        '& .MuiDialogContent-root': {
            padding: theme.spacing(2),
        },
        '& .MuiDialogActions-root': {
            padding: theme.spacing(1),
        },
    }));

    interface DialogTitleProps {
        id: string;
        children?: React.ReactNode;
        onClose: () => void;
    }

    function BootstrapDialogTitle(props: DialogTitleProps) {
        const { children, onClose, ...other } = props;

        return (
            <DialogTitle sx={{ m: 0, p: 2 , }} {...other}>
                {children}
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>
        );
    }


    ///




    return (
        <div className="App border card">
        



            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px' }}>
                <Button variant="contained" startIcon={<AddCircleOutlineTwoToneIcon />} onClick={() => setOpenAdd(true)}>
                    Add Retail User
                </Button>
            </div>

            <div style={{ width: '100%' }}>
                <DataGrid

                    // table customization start
                    sx={{
                        '& .MuiDataGrid-columnHeaderTitle': {
                            whiteSpace: "break-spaces", lineHeight: 1, fontSize: "13px", fontWeight: "bold",
                        },
                        '& .MuiDataGrid-columnHeader': {
                            backgroundColor: "#D0D0D0"
                        },
                        '& .Mui-odd': {
                            textOverflow: "inherit", fontSize: "12px", textAlign: "left"
                        },

                        '& .Mui-even': {
                            backgroundColor: "#F7f7f7", textOverflow: "inherit", fontSize: "12px", textAlign: "left"

                        },

                        '& .Mui-cellown': {
                            paddingTop: 0, paddingBottom: 0

                        },

                    }}

                    getCellClassName={(params) => 'Mui-cellown'}
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'}
                    autoHeight={true}
                    getRowHeight={() => 'auto'}

                    // table customization


                    rows={retAccountsData}
                    columns={columns}

                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 10 },
                        },
                    }}
                    pageSizeOptions={[10, 25, 50]}

                />
            </div>

            <BootstrapDialog
                    fullWidth                    
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={open}>

                    <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                        Retail User Details
                    </BootstrapDialogTitle>

                    <RetailAccountDetails  retailUser={selectedUser}  callback={handleCallBack} ></RetailAccountDetails>

                    <DialogActions>

               

                   
                    </DialogActions>
                </BootstrapDialog>

                <AddRetailUserDialog open={openAdd} onClose={() => setOpenAdd(false)} callback={loadData} />
                <ToastContainer />
        </div>

    );
}


export default RetailCustomers;
